import * as React from "react";

interface CaptureSummaryProps {
  document: DocumentSnakeModel
}

export default function CaptureSummary(props: CaptureSummaryProps) {
  const {
    document,
  } = props;

  const options = { year: "numeric", month: "long", day: "numeric" } as const;
  const created_at_date = new Date(document.created_at);
  const formatted_date = created_at_date.toLocaleDateString("en-US", options);

  return (
    <a href={`/documents/${document.id}`} style={{width: "100%"}}>
      <div className="capture_summary_row">
        <div className="capture_summary_header">
          <h1> {document.title} </h1>
        </div>
        <div className="capture_summary_details">
          <p> <strong> Created: </strong> {formatted_date} <br/> </p>
          <p> <strong> Patient Age: </strong> {document.pretty_age} </p>
        </div>
      </div>
    </a>
  );
}
